module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan lombaire.0893298a.svg";